import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyB3T44gBEJHAIqo1QdZwllzRykG0W0k9-A",
  authDomain: "shuttle-schedule-352d2.firebaseapp.com",
  databaseURL: "https://shuttle-schedule-352d2-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "shuttle-schedule-352d2",
  storageBucket: "shuttle-schedule-352d2.firebasestorage.app",
  messagingSenderId: "109185470725",
  appId: "1:109185470725:web:6dc7e70dcccfe33dfd676c",
  measurementId: "G-63RMXX5W91"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

// Test database connection
const testRef = ref(database, 'test');
onValue(testRef, (snapshot) => {
  console.log('Database connection test:', snapshot.val());
}, (error) => {
  console.error('Database connection error:', error);
});

export { database as db }; 